import { render, staticRenderFns } from "./moreAbout.vue?vue&type=template&id=6549e27d&scoped=true&"
import script from "./moreAbout.vue?vue&type=script&lang=js&"
export * from "./moreAbout.vue?vue&type=script&lang=js&"
import style0 from "./moreAbout.vue?vue&type=style&index=0&id=6549e27d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6549e27d",
  null
  
)

export default component.exports